module.exports = __webpack_public_path__ + "static/img/ServSafe.3b86c99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ServSafe.png
// module id = 424
// module chunks = 4